// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__WiRII","calendarButtons":"ClockData_calendarButtons__1biWY"};